import script from "./DeliveryMethodsNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryMethodsNotice.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryMethodsNotice.vue?vue&type=style&index=0&id=932279a6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-932279a6"]])

export default __exports__